var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.base64Image
    ? _c("section", { class: _vm.bemBlock }, [
        _c("p", [
          _vm._v(
            "\n    " +
              _vm._s(_vm.$msg("search.imagesearch.preview", "search")) +
              "\n  "
          )
        ]),
        _vm._v(" "),
        _c(
          "button",
          {
            class: [_vm.bemElement("close"), "btn-close"],
            on: {
              click: function($event) {
                $event.stopPropagation()
                return _vm.close($event)
              }
            }
          },
          [
            _c("span", { staticClass: "visually-hidden" }, [
              _vm._v(_vm._s(_vm.$msg("global.close", "locale")))
            ])
          ]
        ),
        _vm._v(" "),
        _c("img", { attrs: { src: _vm.base64Image, alt: "Image preview..." } }),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n    " +
              _vm._s(_vm.$msg("search.imagesearch.results", "search")) +
              "\n  "
          )
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }